module.exports = __webpack_public_path__ + "img/checkbox_inactive_small.d171c2f7.svg";